import { type FC } from 'react'
import { configClient } from '@egw/config'
import { Navigate } from 'react-router'
import { useAuth } from '@egw/auth'
import { WEALTH_ROUTES } from '@egw/constants'
import { DemoPage } from '@egw/features-system'

export const HomePage: FC = () => {
  const { isAuthenticated } = useAuth()
  const config = configClient.getConfig() as { env: string }

  if (config.env === 'demo-dev' || config.env === 'demo-prod') {
    return <DemoPage />
  }

  return <Navigate to={isAuthenticated ? WEALTH_ROUTES.OVERVIEW.path : WEALTH_ROUTES.SIGN_IN.path} />
}
